import React from "react";
import Template from '../../_template/_common/Template';
import {
  API_URL,
  LINK_URL,
  ROWS_PER_PAGE,
  LIST_COLUMNS,
  CREATE_FIELDS,
  CREATE_FORM_DATA_DEFAULT,
  UPDATE_FIELDS,
  SHOW_FIELDS,
  ADVANCE_SEARCH_FIELDS,
} from "./__def";

const Main = ({ org_id }) => {
  return (
    <Template
      API_URL={API_URL.replace(':org_id', org_id)}
      LINK_URL={LINK_URL.replace(':org_id', org_id)}
      ROWS_PER_PAGE={ROWS_PER_PAGE}
      LIST_COLUMNS={LIST_COLUMNS}
      CREATE_FIELDS={CREATE_FIELDS}
      CREATE_FORM_DATA_DEFAULT={CREATE_FORM_DATA_DEFAULT}
      UPDATE_FIELDS={UPDATE_FIELDS}
      SHOW_FIELDS={SHOW_FIELDS}
      ADVANCE_SEARCH={ADVANCE_SEARCH_FIELDS}
    />
  );
};

export default Main;
